import { render, staticRenderFns } from "./DeliveryStatusSelector.vue?vue&type=template&id=26c4aa78&"
import script from "./DeliveryStatusSelector.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports